import {IGallerySantaProps, IGalleryStyleParams} from '../types/galleryTypes';
import {IPropsInjectedByViewerScript} from '../types/sliderGalleryTypes';
import {IHostProps} from '@wix/native-components-infra/dist/es/src/types/types';

type ProvidedGlobalPropNames =
  | 'allowFreeProducts'
  | 'addedToCartStatus'
  | 'experiments'
  | 'getCategoryProducts'
  | 'handleAddToCart'
  | 'handleProductItemClick'
  | 'handleProductsOptionsChange'
  | 'sendClickShippingInfoLinkSf'
  | 'htmlTags'
  | 'imageMode'
  | 'imageRatio'
  | 'isFirstPage'
  | 'isInteractive'
  | 'isLiveSiteMode'
  | 'shouldShowMobile'
  | 'isRTL'
  | 'mainCollectionId'
  | 'openQuickView'
  | 'productsManifest'
  | 'productsVariantInfoMap'
  | 'products'
  | 'priceBreakdown'
  | 'shouldShowAddToCartSuccessAnimation'
  | 'shouldShowAddToCartButton'
  | 'shouldShowQuantity'
  | 'shouldShowProductOptions'
  | 'showTitle'
  | 'textsMap'
  | 'totalProducts'
  | 'updateAddToCartStatus'
  | 'productsPriceRangeMap';

export interface ISliderGlobalProps {
  globals?: Pick<IPropsInjectedByViewerScript & IGallerySantaProps, ProvidedGlobalPropNames> & {
    styleParams: IGalleryStyleParams;
  } & Pick<IHostProps, 'updateLayout' | 'dimensions' | 'appLoadBI'>;
}

export const sliderGlobalPropsStrategy = (props: IPropsInjectedByViewerScript & IGallerySantaProps) => {
  const {
    allowFreeProducts,
    addedToCartStatus,
    experiments,
    getCategoryProducts,
    handleAddToCart,
    handleProductItemClick,
    handleProductsOptionsChange,
    htmlTags,
    sendClickShippingInfoLinkSf,
    imageMode,
    imageRatio,
    isFirstPage,
    isInteractive,
    isLiveSiteMode,
    shouldShowMobile,
    isRTL,
    mainCollectionId,
    openQuickView,
    priceBreakdown,
    productsManifest,
    productsVariantInfoMap,
    products,
    shouldShowAddToCartSuccessAnimation,
    shouldShowAddToCartButton,
    shouldShowQuantity,
    shouldShowProductOptions,
    showTitle,
    style,
    textsMap,
    totalProducts,
    updateAddToCartStatus,
    productsPriceRangeMap,
    ...locals
  } = props;

  const {appLoadBI, dimensions, updateLayout} = props.host;
  return {
    globals: {
      allowFreeProducts,
      addedToCartStatus,
      appLoadBI,
      dimensions,
      experiments,
      getCategoryProducts,
      handleAddToCart,
      handleProductItemClick,
      handleProductsOptionsChange,
      htmlTags,
      imageMode,
      imageRatio,
      isFirstPage,
      isInteractive,
      sendClickShippingInfoLinkSf,
      isLiveSiteMode,
      shouldShowMobile,
      isRTL,
      mainCollectionId,
      openQuickView,
      priceBreakdown,
      productsManifest,
      productsVariantInfoMap,
      products,
      shouldShowAddToCartButton,
      shouldShowQuantity,
      shouldShowProductOptions,
      showTitle,
      shouldShowAddToCartSuccessAnimation,
      styleParams: style.styleParams,
      textsMap,
      totalProducts,
      updateAddToCartStatus,
      updateLayout,
      productsPriceRangeMap,
    },
    locals,
  };
};
